import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BookingRevenue from "../../services/travel.revenue";
import AuthService from "../../services/auth.service";

export const Revenuee = createAsyncThunk(
    "revenue/get/travelRevenue",
    async(thunkAPI) => {
        try {
            const data = await BookingRevenue.travelRevenue();
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

// export const logout = createAsyncThunk("auth/logout", async () => {
//   AuthService.logout();
// });

const initialState = {
    loading: false,
    error: "",
    user: AuthService.getUserDetails() || null,
    isLoggedIn: false,
};

const revenueSlice = createSlice({
    name: "revenue",
    initialState,
    extraReducers: {
        [Revenuee.pending]: (state) => {
            state.loading = true;
            state.error = "";
            state.isLoggedIn = false;
            state.user = null;
        },
        [Revenuee.fulfilled]: (state, action) => {
            state.loading = false;
            state.error = "";
            state.isLoggedIn = true;
            state.user = action.payload.user;
        },
        [Revenuee.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
            state.isLoggedIn = false;
            state.user = null;
        },
        // [logout.fulfilled]: (state, action) => {
        //   state.isLoggedIn = false;
        //   state.user = null;
        // },
    },
});

const { reducer } = revenueSlice;
export default reducer;